/* eslint-disable consistent-return,no-param-reassign,no-restricted-globals,@typescript-eslint/no-shadow,@typescript-eslint/no-unused-expressions,@typescript-eslint/no-unused-vars,no-var,vars-on-top */

import { EVENTS } from '../../../../app/constants/events';
import { DESIGNER_EVENTS } from '../../../../app/constants/designer_events';
import { DESIGNER_SETTINGS } from '../../../../app/constants/designer_settings';

xplenty.controller('packages.item.controller', [
  '$scope',
  '$rootScope',
  '$state',
  '$stateParams',
  '$timeout',
  '$interval',
  '$window',
  'Package',
  'modalService',
  'errorsViewerService',
  '$translate',
  'variables',
  'item',
  'notify',
  function (
    $scope,
    $rootScope,
    $state,
    $stateParams,
    $timeout,
    $interval,
    $window,
    Package,
    modalService,
    errorsViewerService,
    $translate,
    variables,
    item,
    notify,
  ) {
    const $win = angular.element($window);

    $scope.loaded = false;
    $scope.designer = null;
    $scope.type = 'item';

    let resizeTimeout;

    const destroyMainScroll = function () {
      angular.element('.page-scroll-wrapper').perfectScrollbar('destroy');
    };

    const packageResize = function () {
      if (resizeTimeout) $timeout.cancel(resizeTimeout);
      resizeTimeout = $timeout(function () {
        $rootScope.$broadcast(DESIGNER_EVENTS.RESIZE, $rootScope.mainSize);
        destroyMainScroll();
        angular.element('.page-scroll-wrapper').scrollTop(0);
      }, 100);
    };

    const validateInterval = 3000;
    let errorsViewer = null;

    var validateStatus = function (validationId) {
      Package.validateStatus($stateParams.id, validationId).subscribe(
        function (res) {
          switch (res.status) {
            case 'running':
              $timeout(function () {
                validateStatus(res.id);
              }, validateInterval);
              break;
            case 'completed':
            case 'failed':
              if (errorsViewer !== null) {
                errorsViewer.show();
              } else {
                errorsViewer = errorsViewerService.createView('Package errors', $scope.designer);
              }

              errorsViewer.setErrors(res.errors);

              $rootScope.$broadcast(DESIGNER_EVENTS.PACKAGE_VALIDATION_LOADING, false);
              break;
            default:
              $rootScope.$broadcast(DESIGNER_EVENTS.PACKAGE_VALIDATION_LOADING, false);
              break;
          }
        },
        function (res) {
          $rootScope.$broadcast(DESIGNER_EVENTS.PACKAGE_VALIDATION_LOADING, false);
        },
      );
    };

    const validate = function () {
      if (errorsViewer) {
        errorsViewer.destroy();
        errorsViewer = null;
      }

      $rootScope.$broadcast(DESIGNER_EVENTS.PACKAGE_VALIDATION_LOADING, true);
      Package.validate($stateParams.id).subscribe(
        function (res) {
          validateStatus(res.id);
        },
        function (res) {},
      );
    };

    $scope.$on(DESIGNER_EVENTS.VALIDATE, validate);
    $scope.$on(DESIGNER_EVENTS.CREATED, function (event, designer) {
      $scope.designer = designer;
    });

    $rootScope.getPackage = function () {
      if ($scope.designer) return $scope.designer.package;
      return null;
    };

    // Router resolve gets the package for us
    $rootScope.title = item.name;
    $scope.package = JSON.parse(JSON.stringify(item));
    $scope.loaded = true;
    $timeout(packageResize, 100);
    $timeout(destroyMainScroll, 1000);

    $win.on('resize', packageResize);

    $scope.$on('$stateChangeStart', function (argument) {
      $win.off('resize', packageResize);
    });

    $scope.$on(DESIGNER_EVENTS.COMPONENT_EDIT, function (event, component) {
      const $tempScope = $rootScope.$new();
      $tempScope.component = component;
      Object.keys(component)
        .filter((key) => typeof component[key] === 'object')
        .forEach((key) => {
          const componentProperty = component[key];
          if (componentProperty && !Array.isArray(componentProperty)) {
            Object.keys(componentProperty).forEach((nestedKey) => {
              if (!Object.getOwnPropertyDescriptor(componentProperty, nestedKey).writable) {
                component[key] = { ...component[key] };
              }
            });
          }
        });
      component.setEdit(true);
      $translate(['package.controller.modals.edit.actions.save', 'package.controller.modals.edit.actions.close']).then(
        function (t) {
          const modalSettings = {
            titleText: component.name,
            descriptionText: component.originalName,
            icon: component.icon,
            closeButtonText: t['package.controller.modals.edit.actions.close'],
            saveButtonText: t['package.controller.modals.edit.actions.save'],
            hasPadding: false,
            hasFooter: false,
            hasScroll: false,
            autoInputFocus: false,
            onSave() {
              $tempScope.$destroy();
              destroyMainScroll();
            },
            onClose() {
              component.setEdit(false);
              $tempScope.$destroy();
              destroyMainScroll();
            },
          };

          modalService.showModal(modalSettings, '<component-editor ng-model="component"/>', $tempScope);
        },
      );
    });

    $scope.$on(DESIGNER_EVENTS.NOTE_EDIT, function (event, note) {
      const $tempScope = $rootScope.$new();

      $tempScope.description = note.description;

      $translate(['package.controller.modals.edit.actions.save', 'package.controller.modals.edit.actions.close']).then(
        function (t) {
          const modalSettings = {
            titleText: t['package.controller.modals.edit.actions.close'],
            closeButtonText: t['package.controller.modals.edit.actions.close'],
            saveButtonText: t['package.controller.modals.edit.actions.save'],
            hasPadding: false,
            hasFooter: false,
            hasScroll: false,
            onSave() {},
            onClose() {
              note.setDescription($tempScope.description);
              note.bind();
              $tempScope.$destroy();
            },
          };
          modalService.showModal(modalSettings, '<note-editor ng-model="description"></note-editor>', $tempScope);
        },
      );
    });

    $scope.$on(DESIGNER_EVENTS.PACKAGE_VARIABLES_EDIT, function (event, vars) {
      if (!modalService.isVisible()) {
        const $tempScope = $rootScope.$new();

        $tempScope.variables = vars;

        $translate([
          'package.controller.modals.edit_variables.actions.save',
          'package.controller.modals.edit_variables.actions.title',
          'package.controller.modals.edit_variables.actions.close',
        ]).then(function (t) {
          const modalSettings = {
            hasPadding: false,
            hasFooter: false,
            onSave() {
              $rootScope.$broadcast(DESIGNER_EVENTS.PACKAGE_VARIABLES_UPDATE, $tempScope.variables);
              modalService.hideModal();
            },
            onClose() {
              $tempScope.$destroy();
            },
          };
          modalService.showModal(
            modalSettings,
            '<package-variables-editor class="package-variables-editor-wrapper" ng-model="variables"></package-variables-editor>',
            $tempScope,
          );
        });

        $scope.$on(EVENTS.PACKAGE_VARIABLES_SAVE, function (event, variables, isInModalPanel) {
          $rootScope.$broadcast(DESIGNER_EVENTS.PACKAGE_VARIABLES_UPDATE, variables);
          if (!isInModalPanel) {
            modalService.hideModal();
            $tempScope.$destroy();
          }
        });
      }
    });

    $scope.$on(DESIGNER_EVENTS.COMPONENT_MENU, function (event, hide) {
      if (!modalService.isVisible()) {
        const $tempScope = $rootScope.$new();

        $tempScope.hasSources = hide.sources;
        $tempScope.hasTransformations = hide.transformations;
        $tempScope.hasDestinations = hide.distanations;
        $tempScope.hasWorkflow = hide.workflow;
        $tempScope.sourceComponentId = hide.sourceComponentId;

        $translate([
          'package.controller.modals.component_menu.actions.save',
          'package.controller.modals.component_menu.actions.title',
          'package.controller.modals.component_menu.actions.description',
          'package.controller.modals.component_menu.actions.close',
        ]).then(function (t) {
          const modalSettings = {
            titleText: t['package.controller.modals.component_menu.actions.title'],
            descriptionText: t['package.controller.modals.component_menu.actions.description'],
            closeButtonText: t['package.controller.modals.component_menu.actions.close'],
            saveButtonText: t['package.controller.modals.component_menu.actions.save'],
            hasPadding: true,
            hasFooter: false,
            onSave() {
              modalService.hideModal();

              $tempScope.$destroy();
            },
            onClose() {
              $tempScope.$destroy();
            },
          };

          modalService.showModal(modalSettings, '<components-list />', $tempScope);
        });
      }
    });

    $scope.$on(DESIGNER_EVENTS.PACKAGE_NAME_EDIT, function (event, _package) {
      const $tempScope = $rootScope.$new();

      $tempScope.package = _package;

      $translate([
        'package.controller.modals.edit_name.actions.save',
        'package.controller.modals.edit_name.actions.title',
        'package.controller.modals.edit_name.actions.close',
      ]).then(function (t) {
        const modalSettings = {
          titleText: t['package.controller.modals.edit_name.actions.title'],
          closeButtonText: t['package.controller.modals.edit_name.actions.close'],
          saveButtonText: t['package.controller.modals.edit_name.actions.save'],
          hasPadding: false,
          hasFooter: false,
          thin: true,
          onClose() {
            $rootScope.title = $scope.designer.package.name;
            $tempScope.$destroy();
          },
        };

        modalService.showModal(
          modalSettings,
          '<package-name-editor class="package-form" ng-model="package"/>',
          $tempScope,
        );
      });
    });

    $scope.$on(DESIGNER_EVENTS.SAVE, function (event, data) {
      $scope.package.name = data.name;
      $scope.package.description = data.description;
      $scope.package.variables = data.variables;
      $scope.package.version_description = data.version_description;
      $scope.package.data_flow_json = data.data_flow_json;
      // Enforce flow_version to be current version
      $scope.package.flow_version = DESIGNER_SETTINGS.FLOW_VERSION;

      Package.update($stateParams.id, $scope.package).subscribe(
        function (res) {
          notify.success(null, $translate.instant('designer.controls.actions.save_package.success'));
          $rootScope.$broadcast(DESIGNER_EVENTS.PACKAGE_SAVED);
          $rootScope.$broadcast(DESIGNER_EVENTS.PACKAGE_UPDATE_VERSION, res);
          angular.isFunction(data.successCallback) && data.successCallback();
        },
        function (err) {
          console.log(err);
        },
      );
    });

    $scope.$on(DESIGNER_EVENTS.PACKAGE_RUN_JOB, function (event, job) {
      if (!modalService.isVisible()) {
        const $tempScope = $rootScope.$new();

        $tempScope.job = job;

        $translate([
          'package.controller.modals.run_job.actions.save',
          'package.controller.modals.run_job.actions.title',
          'package.controller.modals.run_job.actions.close',
        ]).then(function (t) {
          const modalSettings = {
            titleText: t['package.controller.modals.run_job.actions.title'],
            closeButtonText: t['package.controller.modals.run_job.actions.close'],
            saveButtonText: t['package.controller.modals.run_job.actions.save'],
            hasPadding: false,
            hasFooter: false,
            hasScroll: false,
            onSave() {
              $rootScope.createJob($tempScope.job, function () {
                modalService.hideModal();
              });
              destroyMainScroll();
            },
            onClose() {
              destroyMainScroll();
            },
          };

          modalService.showModal(modalSettings, '<job-form ng-model="job"/>', $tempScope);
        });
      }
    });

    // Bind shortcut events
    $scope.$on(EVENTS.SHORTCUTS_DESIGNER_SAVE, function () {
      $scope.designer.save();
    });
    $scope.$on(EVENTS.SHORTCUTS_DESIGNER_SELECT_ALL, function () {
      $scope.designer.package.selectAllComponents();
    });
    $scope.$on(EVENTS.SHORTCUTS_DESIGNER_UNSELECT, function () {
      $scope.designer.package.unselectAllComponents();
    });
    $scope.$on(EVENTS.SHORTCUTS_DESIGNER_SELECT_VERTICAL_ALIGN, function () {
      $scope.designer.package.align();
    });
    $scope.$on(EVENTS.SHORTCUTS_DESIGNER_UNDO, function () {
      $scope.designer.undo();
    });
    $scope.$on(EVENTS.SHORTCUTS_DESIGNER_REDO, function () {
      $scope.designer.redo();
    });
    $scope.$on(EVENTS.SHORTCUTS_DESIGNER_CUT, function () {
      $scope.designer.cut();
    });
    $scope.$on(EVENTS.SHORTCUTS_DESIGNER_COPY, function () {
      $scope.designer.copy();
    });
    $scope.$on(EVENTS.SHORTCUTS_DESIGNER_PASTE, function () {
      $scope.designer.paste();
    });

    const confirmationMessage =
      'The changes you made may not be saved.\n Click OK to leave this package without saving the changes';

    const removeModal = function () {
      $('.modal-backdrop').remove();
      $('.modal').remove();
    };

    let skipStateChangeStart;
    var redirectEventListener = $scope.$on('$stateChangeStart', function (event, toState, toParams, fromState) {
      // ui router bug calls the listener twice if state change was prevented
      if (skipStateChangeStart) {
        skipStateChangeStart = false;
        event.preventDefault();
        return;
      }

      if ($scope.designer && $scope.designer.package.dataChanged) {
        event.preventDefault();
        const confirmed = confirm(confirmationMessage);
        if (confirmed) {
          redirectEventListener();
          $win.off('beforeunload');
          // $state.go(toState.name, toParams);
          removeModal();
        } else {
          skipStateChangeStart = true;
          event.preventDefault();
          removeModal();
        }
      } else {
        removeModal();
      }
    });

    $win.on('beforeunload', function (e) {
      if ($scope.designer.package.dataChanged) {
        (e || window.event).returnValue = confirmationMessage;
        return confirmationMessage;
      }
    });
  },
]);
